import './common.css'; 

const LoadingWidget = () => <div className="loader"></div>;

export default LoadingWidget;
